// DEV
const env = {
  apiUrl: 'http://localhost:3000',
  port: 3000,
  recaptcha: {
    sitekey: '6Lfx-18UAAAAAKtsjeFQB5w0cefiFuokJymGHyog',
    secretKey: '6Lfx-18UAAAAAEihgz5SwW-a3VcoQT1GFtLHjkZD',
  },
  mailer: {
    apiKey: 'key-63b065ee0bd81aa9d419ef5ab63e6331',
    domain: 'corvette.lumensoftware.io',
    from: '"Lumen Software" <inquire@lumensoftware.io>',
    inquiryFrom: 'inquire@lumensoftware.io',
    inquiryTo: 'inquire@lumensoftware.io',
  },
};

module.exports = {
  env,
};
